import { Component, EventEmitter, Input, Output, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { PROSPECTS_LABEL } from '@shared';
import { difference } from 'lodash';

import { ALL_SELECTED } from '@shared/models';
import { Subscription } from 'rxjs';

export const OTHER = 'Other';

@Component({
  selector: 'mojo-statuses-assign-select',
  templateUrl: './statuses-assign-select.component.html',
})
export class StatusesAssignSelectComponent implements OnInit, OnDestroy {
  @Input() statuses: string[];
  @Input() isDisabled = false;
  @Output() selection = new EventEmitter<string[]>();

  activeStatusFilters: string[] =
    !!this.route.snapshot.queryParams.shortlistedFilters &&
    !this.route.snapshot.queryParams.shortlistedFilters.includes(PROSPECTS_LABEL) &&
    this.route.snapshot.queryParams.shortlistedFilters.length !== 0
      ? JSON.parse(this.route.snapshot.queryParams.shortlistedFilters)
      : [ALL_SELECTED];

  form = this.fb.group({
    filter: [this.activeStatusFilters, null],
  });
  filter = this.form.get('filter');
  previouslySelected = [ALL_SELECTED];
  sub = new Subscription();

  constructor(private fb: UntypedFormBuilder, private route: ActivatedRoute) {
    this.filter.valueChanges.subscribe((selectedStatuses) => {
      if (selectedStatuses.length > 1 && selectedStatuses.includes(ALL_SELECTED)) {
        return;
      } else if (selectedStatuses.length === 1 && selectedStatuses.includes(ALL_SELECTED)) {
        this.selection.emit(this.statuses.filter((status) => status === ALL_SELECTED));
      } else {
        this.selection.emit(selectedStatuses);
      }
    });
  }

  ngOnInit() {
    this.sub.add(
      this.route.queryParams.subscribe((queryParams: Params) => {
        if (!!queryParams && queryParams.shortlistedFilters === '[]') {
          this.filter.setValue([ALL_SELECTED]);
        } else if (!!queryParams && !!queryParams.shortlistedFilters) {
          this.filter.setValue(JSON.parse(queryParams.shortlistedFilters), { emitEvent: false });
        }
      }),
    );
  }

  selectionChange(e) {
    const selectedStatuses = e.value;
    const diff = difference(selectedStatuses, this.previouslySelected);

    if (selectedStatuses.length === 0) {
      this.filter.setValue([ALL_SELECTED]);
    } else if (
      selectedStatuses.length > 0 &&
      selectedStatuses.includes(ALL_SELECTED) &&
      !diff.includes(ALL_SELECTED)
    ) {
      this.filter.setValue(this.filter.value.filter((val) => val !== ALL_SELECTED));
    } else if (
      selectedStatuses.length > 0 &&
      selectedStatuses.includes(ALL_SELECTED) &&
      diff.includes(ALL_SELECTED)
    ) {
      this.filter.setValue([ALL_SELECTED]);
    }
    this.previouslySelected = this.filter.value;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
